import { Select } from '@smartgift/frontend-toolkit';
import { useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { AppLoader } from '@hero/atoms';
import { QUERY_KEYS, Z_INDEX } from '@hero/constants';
import { useCreateTag } from '@hero/services/contact-service/hooks';

export function AddTagsToSelectedContacts({
  tags,
  setTags,
  options,
  onApply,
  onMenuClose,
  inputPlaceholderOnMenu,
  ...props
}) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { mutateAsync: mutateAsyncCreateTag, isLoading: isLoadingCreateTag } = useCreateTag();

  return (
    <>
      <Select
        size="sm"
        menuWidth="320px"
        value={tags}
        placeholder={t('addTags')}
        options={options?.docs?.map(doc => ({ label: doc.name, value: doc.id })) || []}
        showSelectedOptionInPlaceholder={false}
        onFilterChange={setTags}
        onChange={e => {
          setTags(e);
        }}
        hasMenuSearch
        inputPlaceholderOnMenu={inputPlaceholderOnMenu || t('searchTags')}
        isMulti
        onApply={() => {
          onApply();
        }}
        onCreateOption={async inputValue => {
          const response = await mutateAsyncCreateTag({
            name: inputValue
          });

          queryClient.invalidateQueries({
            queryKey: [QUERY_KEYS.useGetTagListKey],
            refetchType: 'active'
          });

          const newOption = {
            label: response.name,
            value: response.id
          };

          setTags([newOption, ...(tags || [])]);

          return newOption;
        }}
        styles={{
          menuPortal: () => ({
            zIndex: Z_INDEX.customFilter
          })
        }}
        creatable
        onMenuClose={onMenuClose}
        {...props}
      />
      {isLoadingCreateTag && <AppLoader />}
    </>
  );
}
